import type { CurriculumTier, CurriculumTierId, Trin } from '../../types';
import { GRUNDNIVEAU_TIER } from './grundniveau';
import { NIVEAU_1_TIER } from './niveau-1';
import { NIVEAU_2_TIER } from './niveau-2';
import { NIVEAU_3_TIER } from './niveau-3';
import { NIVEAU_4_TIER } from './niveau-4';
import { NIVEAU_5_TIER } from './niveau-5';
import { NIVEAU_6_TIER } from './niveau-6';

export { getDictationUnitTexts, DICTATION_UNITS } from './dictationUnits';
export * from './generators';

export const CURRICULUM: CurriculumTier[] = [
  GRUNDNIVEAU_TIER,
  NIVEAU_1_TIER,
  NIVEAU_2_TIER,
  NIVEAU_3_TIER,
  NIVEAU_4_TIER,
  NIVEAU_5_TIER,
  NIVEAU_6_TIER,
];

export const ALL_TRINS: Trin[] = CURRICULUM.flatMap((t) => t.trins);

const TRIN_MAP = new Map(ALL_TRINS.map((t) => [t.id, t]));
const TIER_MAP = new Map(CURRICULUM.map((t) => [t.id, t]));

export function getTrin(id: string): Trin | undefined {
  return TRIN_MAP.get(id);
}

export function getTier(id: CurriculumTierId): CurriculumTier | undefined {
  return TIER_MAP.get(id);
}

/** @deprecated Use ALL_TRINS */
export const LEVELS = ALL_TRINS;

export const ALL_TAUGHT_KEYS: string[] = Array.from(
  new Set(ALL_TRINS.flatMap((t) => t.unlockedKeys)),
);

export {
  CHECKPOINTS,
  getCheckpoint,
  getCheckpointAfterTier,
} from '../checkpoints';

export {
  MINI_CHECKPOINTS,
  getMiniCheckpoint,
  getMiniCheckpointAfterTrin,
  miniCheckpointsInTier,
} from '../miniCheckpoints';

export function trinEstimatedChars(trin: Trin): number {
  return trin.rounds.reduce((sum, r) => sum + r.generate({}).length, 0);
}
